export default __webpack_public_path__ + "static/nesting_gantries-5b92f3b4bc516913e9133adf816fc94d.png";